export const ShopInfo = {
    "Name": "GoDigex Mart",
    "Address": "Bangalore",
    "Phone": "+91 7019922900",
    "Whatsapp": "+917019922900",
    "WhatsappMessageHeader": "Hello.Please find the below order.",
    "OpenTime": "08:30 AM",
    "CloseTime": "7:00 PM",
    "CartEmptyMessage": "Your cart is empty now. Add items to place order.",
    "gstRate": 0.18,
    "GSTNumber": "29AAACG1234Q1Z5"
}

